var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuenchCoolBoost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#025C85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 30.8787C14.4786 32.118 14.9364 33.3499 15.8296 34.3399C17.0801 35.7281 18.8889 36.3198 20.6083 36.0816",
    fill: "#025C85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 30.8787C14.4786 32.118 14.9364 33.3499 15.8296 34.3399C17.0801 35.7281 18.8889 36.3198 20.6083 36.0816",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2293 24.377C30.4813 22.7395 27.3885 16.2674 22.3046 9.15145C21.858 8.52992 20.9276 8.52992 20.4847 9.15145C15.3971 16.2674 12.3043 22.7395 11.5563 24.377C10.8231 25.8509 10.4062 27.4921 10.4062 29.2488C10.4062 35.3152 15.3264 40.2242 21.3928 40.2242C27.4592 40.2242 32.3794 35.3152 32.3794 29.2488C32.3794 27.4921 31.9625 25.8509 31.2293 24.377Z",
    fill: "#025C85",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4298,
    cy: 15.7333,
    r: 9.86728,
    fill: "#025C85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5781 8.6853V24.6609",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3555 10.1963L32.5811 12.2325L34.7788 10.1403",
    fill: "#025C85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3555 10.1963L32.5811 12.2325L34.7788 10.1403",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7788 23.5846L32.551 21.5484L30.3555 23.6406",
    fill: "#025C85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7788 23.5846L32.551 21.5484L30.3555 23.6406",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3319 12.4328L25.8359 20.9781",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8594 11.3522L36.332 14.3226L39.2745 15.0609",
    fill: "#025C85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8594 11.3522L36.332 14.3226L39.2745 15.0609",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9112 22.2523L28.4385 19.2819L25.4961 18.5458",
    fill: "#025C85"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9112 22.2523L28.4385 19.2819L25.4961 18.5458",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4414 12.5963L39.2387 20.6465",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8693 11.4275L28.5043 14.3785L25.5898 15.2201",
    fill: "#025C85"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8693 11.4275L28.5043 14.3785L25.5898 15.2201",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2092 21.9961L36.5742 19.0473L39.4887 18.2035",
    fill: "#025C85"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2092 21.9961L36.5742 19.0473L39.4887 18.2035",
    stroke: "white",
    strokeWidth: 0.836369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuenchCoolBoost);
export default __webpack_public_path__ + "static/media/quench-cool-boost.7a20b70b4c9a997d9c77a0fc1c51db56.svg";
export { ForwardRef as ReactComponent };